// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 9323) return "static/chunks/25b8c134.16eb2ff71ee999f2.js";
	if (chunkId === 6079) return "static/chunks/363642f4.0716f73985ea7e0d.js";
	if (chunkId === 8897) return "static/chunks/71d5b6fe.beb5050da26e5020.js";
	if (chunkId === 601) return "static/chunks/601.210c9030249f6ee3.js";
	if (chunkId === 1569) return "static/chunks/1569.7881fefe487a5793.js";
	if (chunkId === 1481) return "static/chunks/1481.9872fadf6ca134d5.js";
	if (chunkId === 8042) return "static/chunks/8042.611efcbfbb08453f.js";
	if (chunkId === 3777) return "static/chunks/3777.1a0008ced43739db.js";
	if (chunkId === 1336) return "static/chunks/1336.0d0089c5bb7aacb6.js";
	if (chunkId === 6713) return "static/chunks/6713.c3238d60f6ad6c4d.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"2266":"870fdd6f","2545":"c16f53c3","7330":"d3ac728e","8229":"9da6db1e"}[chunkId] || chunkId) + "-GaMPIyWp0Rk1B364PH8Bx.js";
};